const ExternalLinkIcon = () => {
  return (
    <svg viewBox="0 0 24 24">
      <g fill="none">
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3" />
      </g>
    </svg>
  );
};

export default ExternalLinkIcon;
